// components/marketer/MarketerSignupModal.jsx
import { useState } from "react";
import { X, Loader2, CheckCircle } from "lucide-react";
import { statesAndLgas } from "../stateAndLga";


export default function MarketerSignupModal({ onClose }) {
  const [form, setForm] = useState({
    name: "", email: "", password: "", state: "", lga: ""
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.password || !form.state || !form.lga) {
      alert("Please fill all fields");
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}marketer/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      const data = await res.json();

      if (data.success) {
        setSuccess(true);
        setTimeout(() => onClose(), 3000);
      } else {
        alert(data.message || "Failed to submit");
      }
    } catch (err) {
        console.log(err)
      alert("Network error");
    }
    setSubmitting(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-3xl w-full max-w-2xl p-10 relative">
        <button onClick={onClose} className="absolute top-6 right-6 p-3 hover:bg-gray-100 rounded-full transition">
          <X className="w-8 h-8" />
        </button>

        {!success ? (
          <>
            <h2 className="text-3xl font-bold text-center mb-8 text-orange-700">
              Join Ejob as a Marketer
            </h2>
            <div className="space-y-6">
              <input placeholder="Full Name" className="w-full p-4 border-2 rounded-xl focus:border-purple-500 text-base" onChange={e => setForm({...form, name: e.target.value})} />
              <input placeholder="Email Address" type="email" className="w-full p-4 border-2 rounded-xl focus:border-purple-500 text-base" onChange={e => setForm({...form, email: e.target.value})} />
              <input placeholder="Password" type="password" className="w-full p-4 border-2 rounded-xl focus:border-purple-500 text-base" onChange={e => setForm({...form, password: e.target.value})} />
              
              <select className="w-full p-4 border-2 rounded-xl focus:border-purple-500 text-base" onChange={e => setForm({...form, state: e.target.value})}>
                <option value="">Select State</option>
                {Object.keys(statesAndLgas).map(s => <option key={s} value={s}>{s}</option>)}
              </select>

              <select disabled={!form.state} className="w-full p-4 border-2 rounded-xl focus:border-purple-500 text-base" onChange={e => setForm({...form, lga: e.target.value})}>
                <option value="">Select LGA</option>
                {form.state && statesAndLgas[form.state]?.map(lga => <option key={lga} value={lga}>{lga}</option>)}
              </select>

              <button
                onClick={handleSubmit}
                disabled={submitting}
                className="w-full  bg-gradient-to-br from-orange-500 via-orange-600 to-red-600 text-white py-5 rounded-xl font-bold text-xl hover:from-purple-700 hover:to-pink-700 disabled:opacity-70 flex items-center justify-center gap-3 transition shadow-xl"
              >
                {submitting ? <><Loader2 className="animate-spin w-8 h-8" /> Submitting...</> : "Submit Application"}
              </button>
            </div>
          </>
        ) : (
          <div className="text-center py-20">
            <CheckCircle className="w-24 h-24 text-green-500 mx-auto mb-6" />
            <h2 className="text-3xl font-bold text-green-600 mb-4">Application Submitted!</h2>
            <p className="text-xl text-gray-700">An admin will review and approve your account soon.</p>
          </div>
        )}
      </div>
    </div>
  );
}